module.exports = __webpack_public_path__ + "img/planner-eezy-work-icon.c82c7be.png";